import { DocumentViewerScreen } from '@/modules/profile/components/DocumentViewerScreen';
import React from 'react';

export default function DocumentViewer() {
    return <DocumentViewerScreen />;
}

